const formatValue = (value: number): string => value.toString();
// Intl.NumberFormat('en-US', {
//   style: 'currency',
//   currency: 'USD',
// }).format(value);

export default formatValue;
